const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2.336 24.208C2.112 24.608 1.896 24.848 1.688 24.928C1.576 24.976 1.456 25 1.328 25C0.864 25 0.544 24.76 0.368 24.28C0.336 24.184 0.32 21.608 0.32 16.552C0.32 11.432 0.328 8.808 0.344 8.68C0.536 6.584 1.36 4.84 2.816 3.448C4.288 2.056 6.04 1.256 8.072 1.048C8.152 1.032 8.264 1.024 8.408 1.024C8.472 0.991999 8.712 0.991999 9.128 1.024C9.848 1.024 10.568 1.112 11.288 1.288C12.856 1.704 14.2 2.488 15.32 3.64C16.696 5.064 17.464 6.744 17.624 8.68C17.64 8.808 17.648 11.432 17.648 16.552C17.648 21.608 17.632 24.184 17.6 24.28C17.456 24.744 17.136 24.976 16.64 24.976C16.16 24.976 15.832 24.72 15.656 24.208C15.656 22.496 15.648 19.92 15.632 16.48C15.616 13.04 15.608 10.456 15.608 8.728L15.56 8.416C15.336 7.104 14.776 5.984 13.88 5.056C12.52 3.696 10.888 3.016 8.984 3.016C7.912 3.016 6.88 3.264 5.888 3.76C4.976 4.208 4.208 4.84 3.584 5.656C2.976 6.456 2.584 7.376 2.408 8.416L2.36 8.728L2.336 16.48V24.208Z",
  fill: "#1E3F6B"
});

const SvgEquationIntegrals9 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationIntegrals9, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-integrals-9.bd680e49.svg";
export { ForwardRef as ReactComponent };